import React from 'react';

import { Box, xcss } from '@atlaskit/primitives';

type VideoPlayerProps = {
	url: string;
	title: string;
};

const containerStyles = xcss({
	aspectRatio: '16 / 9',
});

/**
 * __Video player__
 */
export const VideoPlayer = ({ url, title }: VideoPlayerProps) => {
	return (
		<Box xcss={containerStyles}>
			<iframe
				width="100%"
				height="100%"
				src={url}
				title={title}
				frameBorder="0"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
				referrerPolicy="strict-origin-when-cross-origin"
				allowFullScreen
			/>
		</Box>
	);
};
